module.exports = "/images/marking-icon-measure_new.svg?7da3394554b18fe830e270e149e0b6e4";